import React from "react";

import { SvgComponentProps } from "../GenericIconType";
import { SvgWrapper } from "../styles";

const RoutingIcon = (props: SvgComponentProps) => {
  const { width, height, color, onClick } = props;

  return (
    <SvgWrapper onClick={onClick}>
      <svg
        width={width}
        height={height}
        viewBox={`0 0 ${width} ${height}`}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g id="Outlined/routing">
          <g id="icon">
            <path
              d="M3.64673 7.16683C3.1734 7.16683 2.6934 6.9935 2.32673 6.64016C1.10006 5.4735 0.606729 4.20016 0.893396 2.9535C1.2334 1.48683 2.52006 0.833496 3.64673 0.833496C4.7734 0.833496 6.06673 1.4935 6.40006 2.9535C6.68673 4.20016 6.18673 5.4735 4.96673 6.64016C4.60006 6.9935 4.12673 7.16683 3.64673 7.16683ZM1.86673 3.18016C1.6134 4.2935 2.3534 5.28016 3.02006 5.9135C3.3734 6.2535 3.92673 6.24683 4.28006 5.9135C4.94673 5.28016 5.68673 4.2935 5.42673 3.1735C5.20006 2.18683 4.32673 1.8335 3.6534 1.8335C2.9734 1.8335 2.10006 2.18683 1.86673 3.18016Z"
              fill={color}
            />
            <path
              d="M3.67314 4.13363C3.30647 4.13363 3.00647 3.83363 3.00647 3.46696C3.00647 3.10029 3.2998 2.80029 3.67314 2.80029H3.6798C4.04647 2.80029 4.34647 3.10029 4.34647 3.46696C4.34647 3.83363 4.04647 4.13363 3.67314 4.13363Z"
              fill={color}
            />
            <path
              d="M12.3265 15.167C11.8532 15.167 11.3732 14.9937 10.9999 14.6403C9.76654 13.4737 9.26654 12.2003 9.55988 10.947C9.89988 9.48699 11.1932 8.82699 12.3265 8.82699C13.4599 8.82699 14.7532 9.48699 15.0932 10.947C15.3799 12.1937 14.8799 13.4737 13.6465 14.6337C13.2799 14.9937 12.8065 15.167 12.3265 15.167ZM12.3265 9.83365C11.6465 9.83365 10.7665 10.187 10.5332 11.1803C10.2732 12.2937 11.0199 13.287 11.6865 13.9203C12.0399 14.2603 12.5999 14.2603 12.9599 13.9203C13.6265 13.287 14.3732 12.3003 14.1132 11.187C13.8932 10.187 13.0132 9.83365 12.3265 9.83365Z"
              fill={color}
            />
            <path
              d="M12.3531 12.1336C11.9865 12.1336 11.6865 11.8336 11.6865 11.467C11.6865 11.1003 11.9798 10.8003 12.3531 10.8003H12.3598C12.7265 10.8003 13.0265 11.1003 13.0265 11.467C13.0265 11.8336 12.7198 12.1336 12.3531 12.1336Z"
              fill={color}
            />
            <path
              d="M7.99992 13.1668H6.21325C5.43992 13.1668 4.76659 12.7002 4.49992 11.9802C4.22659 11.2602 4.42659 10.4668 5.00659 9.9535L10.3333 5.2935C10.6533 5.0135 10.6599 4.6335 10.5666 4.3735C10.4666 4.1135 10.2133 3.8335 9.78659 3.8335H7.99992C7.72659 3.8335 7.49992 3.60683 7.49992 3.3335C7.49992 3.06016 7.72659 2.8335 7.99992 2.8335H9.78659C10.5599 2.8335 11.2333 3.30016 11.4999 4.02016C11.7733 4.74016 11.5733 5.5335 10.9933 6.04683L5.66659 10.7068C5.34659 10.9868 5.33992 11.3668 5.43325 11.6268C5.53325 11.8868 5.78659 12.1668 6.21325 12.1668H7.99992C8.27325 12.1668 8.49992 12.3935 8.49992 12.6668C8.49992 12.9402 8.27325 13.1668 7.99992 13.1668Z"
              fill={color}
            />
            <path
              d="M7.99992 13.1668H6.21325C5.43992 13.1668 4.76659 12.7002 4.49992 11.9802C4.22659 11.2602 4.42659 10.4668 5.00659 9.9535L10.3333 5.2935C10.6533 5.0135 10.6599 4.6335 10.5666 4.3735C10.4666 4.1135 10.2133 3.8335 9.78659 3.8335H7.99992C7.72659 3.8335 7.49992 3.60683 7.49992 3.3335C7.49992 3.06016 7.72659 2.8335 7.99992 2.8335H9.78659C10.5599 2.8335 11.2333 3.30016 11.4999 4.02016C11.7733 4.74016 11.5733 5.5335 10.9933 6.04683L5.66659 10.7068C5.34659 10.9868 5.33992 11.3668 5.43325 11.6268C5.53325 11.8868 5.78659 12.1668 6.21325 12.1668H7.99992C8.27325 12.1668 8.49992 12.3935 8.49992 12.6668C8.49992 12.9402 8.27325 13.1668 7.99992 13.1668Z"
              fill={color}
            />
          </g>
        </g>
      </svg>
    </SvgWrapper>
  );
};

export default RoutingIcon;
